export default __webpack_public_path__ + "static/download-image-5-6dce40cbb7300dd94005c0eb6d43b5db.png";